import script from "./RoutingAddressesEmptySiren.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutingAddressesEmptySiren.vue?vue&type=script&setup=true&lang=ts"

import "./RoutingAddressesEmptySiren.vue?vue&type=style&index=0&id=467b0ae8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-467b0ae8"]])

export default __exports__